module.exports = __webpack_public_path__ + "front/img/66.0da05cf7.jpg";